/**
 * Consent + visitor cookies for first-party analytics.
 *
 * st_consent=analytics  → statistics allowed; st_vid may be set
 * st_consent=necessary  → rejected analytics; st_vid cleared
 * missing               → no choice yet; banner shown, no tracking
 */
const CONSENT_COOKIE = 'st_consent'
const VISITOR_COOKIE = 'st_vid'
const CONSENT_MAX_AGE = 60 * 60 * 24 * 180 // 180 days
const VISITOR_MAX_AGE = 60 * 60 * 24 * 365 // 1 year

function secureFlag() {
  return typeof window !== 'undefined' && window.location.protocol === 'https:'
    ? '; Secure'
    : ''
}

export function getCookie(name) {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : null
}

function setCookie(name, value, maxAge) {
  document.cookie =
    `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secureFlag()}`
}

function clearCookie(name) {
  document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax${secureFlag()}`
}

export function getConsent() {
  const value = getCookie(CONSENT_COOKIE)
  if (value === 'analytics' || value === 'necessary') return value
  return null
}

export function hasAnalyticsConsent() {
  return getConsent() === 'analytics'
}

function newVisitorId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  // Fallback for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function getOrCreateVisitorId() {
  let id = getCookie(VISITOR_COOKIE)
  if (id && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id)) {
    return id
  }
  id = newVisitorId()
  setCookie(VISITOR_COOKIE, id, VISITOR_MAX_AGE)
  return id
}

export function acceptAnalytics() {
  setCookie(CONSENT_COOKIE, 'analytics', CONSENT_MAX_AGE)
  return getOrCreateVisitorId()
}

export function rejectAnalytics() {
  setCookie(CONSENT_COOKIE, 'necessary', CONSENT_MAX_AGE)
  clearCookie(VISITOR_COOKIE)
}

/** Notify listeners (banner / beacon) that consent changed. */
export function emitConsentChange() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('st:consent'))
  }
}
